import {
	borderColor,
	brandPrimaryHover,
	brandSecondary,
	header,
	hotPink,
	titles,
	warningDark,
} from '../../../../web/styles/colors';
import { CssSelectors, DefaultBorder, Layouts, truncateTextStyle } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	actions: {
		width: 60,
	},
	body: {
		maxHeight: 0,
		overflow: 'hidden',
		transition: 'max-height .25s ease-in-out',
	},
	bodyExpanded: {
		maxHeight: 'initial',
	},
	campaignHeader: {
		alignItems: 'center',
		borderBottom: '1px solid #E3E7E9',
		color: '#767676',
		display: 'flex',
		fontSize: 11,
		justifyContent: 'space-between',
		letterSpacing: 1.1,
		margin: '20px 10px 10px',
		padding: '10px 0',
		textTransform: 'uppercase',
	},
	chevron: {
		cursor: 'pointer',
	},
	container: {
		border: '1px solid #d3dbde',
		borderRadius: 3,
		boxShadow: '0px 0px 6px #8b8b8b33',
		boxSizing: 'border-box',
		marginBottom: 20,
		minHeight: 60,
		overflowY: 'hidden',
		padding: '16px 12px',
		position: 'relative',
	},
	containerSocial: {
		border: '1px solid #8ccfe9',
		boxShadow: '0px 0px 6px #00aae8',
	},
	containerTemplateRow: {
		':last-child': {
			borderBottom: 'none',
		},
		borderBottom: `1px solid ${borderColor}`,
		display: 'flex',
		margin: '0 10px',
		padding: '10px 0',
	},
	created: {
		color: titles,
		fontSize: '0.75rem',
		width: 100,
	},
	draft: {
		color: hotPink,
		fontSize: '0.75rem',
		marginLeft: '0.5rem',
	},
	dropdownMenu: {
		position: 'relative',
	},
	dropdownTrigger: {
		border: DefaultBorder,
		borderRadius: 3,
		color: header,
		fontSize: '0.825rem',
		maxWidth: 300,
		minWidth: 160,
		padding: '0.5rem',
		...CssSelectors.allChildren(
			{
				...truncateTextStyle,
			},
			'.select-box-trigger-content'
		),
	},
	expanderSection: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allDescendants(
			{
				height: 9,
				margin: '-20px 10px 0',
				width: 17,
			},
			'.disclosure-icon'
		),
	},
	expired: {
		background: '#e40000',
	},
	expires: {
		background: '#ff8a27',
		borderRadius: 2,
		color: 'white',
		fontSize: 11,
		margin: '0.25rem 0.25rem 0.25rem 0.5rem',
		padding: '0.125rem 0.25rem',
	},
	gripper: {
		marginTop: 5,
	},
	headerActions: {
		marginRight: 30,
		width: 60,
	},
	headerCreated: {
		width: 100,
	},
	headerIndustries: {
		width: 120,
	},
	headerName: {
		marginLeft: 35,
		width: 400,
		...truncateTextStyle,
	},
	industries: {
		color: titles,
		fontSize: '0.75rem',
		width: 120,
		...truncateTextStyle,
	},
	inputTitle: {
		color: titles,
		fontSize: '0.825rem',
		margin: '0.5rem 0 0.25px',
	},
	invert: {
		transform: 'rotate3d(0,0,1,180deg)',
	},
	items: {
		alignItems: 'center',
		display: 'flex',
		flexGrow: 1,
		justifyContent: 'space-between',
	},
	modalButtons: {
		marginTop: '1rem',
		...Layouts.horizontalStack('1rem'),
	},
	modalTitle: {
		color: brandSecondary,
		fontSize: '1.125rem',
	},
	name: {
		alignItems: 'center',
		color: brandPrimaryHover,
		display: 'flex',

		fontSize: 16,
		height: 25,
		marginLeft: 23,
		width: 415,
		...truncateTextStyle,
	},
	title: {
		color: titles,
		fontSize: 20,
		marginBottom: 4,
		marginLeft: 20,
		marginRight: 20,
	},
	titleRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		position: 'absolute',
		width: '96%',
	},
	titleSection: {
		':first-child': {
			height: 16,
			marginTop: 5,
		},
		alignItems: 'center',
		display: 'flex',
	},
	total: {
		color: '#858585',
		fontSize: 16,
		marginRight: 50,
	},
	edit: {
		cursor: 'pointer',
		marginRight: 20,
		verticalAlign: 'middle',
	},
	trash: {
		cursor: 'pointer',
		marginRight: 30,
		verticalAlign: 'middle',
	},
	trashFiller: {
		width: 46,
	},
	uncategorized: {
		color: warningDark,
	},
	unpublished: {
		color: '#C75DA6',
		fontSize: 18,
		marginRight: 40,
	},
});
